import { render, staticRenderFns } from "./orderCreateCrm.vue?vue&type=template&id=6db9319a&scoped=true&"
import script from "./orderCreateCrm.vue?vue&type=script&lang=js&"
export * from "./orderCreateCrm.vue?vue&type=script&lang=js&"
import style0 from "./orderCreateCrm.vue?vue&type=style&index=0&id=6db9319a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9319a",
  null
  
)

export default component.exports